import _ from 'lodash';
import React, { useContext } from 'react';
import { useIntl } from 'react-intl';
import {
  EmptyComponent,
  Evidence,
  SnackbarContext,
  SnackbarVariant,
} from '@eas/common-web';
import { useAuthoredEvidence } from '@composite/evidence/authored-evidence';
import { UserSubstitution } from '@models';
import { EntityName, EvidenceApiUrl } from '@enums';
import { useColumns } from './user-substitution-columns';
import { Fields } from './user-substitution-fields';
import { useUserSubstitutionHookedSources } from './user-substitution-hooked-sources';
import { useValidationSchema } from './user-substitution-schema';

const getErrorMessage = (
  err: Error,
  showSnackbar: SnackbarContext['showSnackbar']
) => {
  if (_.get(err, 'code') === 'OVERLAPPING_SUBSTITUTION') {
    showSnackbar(
      'Chyba uložení dat: Zástup se překrývá s již existujícím zástupem.',
      SnackbarVariant.ERROR
    );
    throw err;
  }

  showSnackbar(
    `Chyba uložení dat: ${_.get(err, 'code')}`,
    SnackbarVariant.ERROR
  );
  throw err;
};

export function UserSubstitutions() {
  const intl = useIntl();

  const validationSchema = useValidationSchema();
  const { showSnackbar } = useContext(SnackbarContext);

  const evidence = useAuthoredEvidence<UserSubstitution>({
    identifier: 'USER_SUBSTITUTIONS',
    apiProps: {
      url: EvidenceApiUrl.USER_SUBSTITUTIONS,
      hookedSources: useUserSubstitutionHookedSources,
      handleCreateError: (err) => getErrorMessage(err, showSnackbar),
      handleUpdateError: (err) => getErrorMessage(err, showSnackbar),
    },
    tableProps: {
      columns: useColumns(),
      tableName: intl.formatMessage({
        id: 'ES__USER_SUBSTITUTIONS__TABLE__TITLE',
        defaultMessage: 'Zástupy uživatelů',
      }),
      defaultSorts: [],
      showReportButton: false,
    },
    detailProps: {
      entityName: EntityName.USER_SUBSTITUTION,
      FieldsComponent: Fields,
      GeneralFieldsComponent: EmptyComponent,
      toolbarProps: {
        title: intl.formatMessage({
          id: 'ES__USER_SUBSTITUTIONS__DETAIL__TITLE',
          defaultMessage: 'Zástup uživatele',
        }),
        showBtn: (name) => !['REMOVE'].includes(name),
      },
      validationSchema,
    },
  });

  return <Evidence {...evidence} />;
}
